<div
  class="flex flex-row w-full border-1 text-white items-center align-center justify-center border-neutral-600 border-0 pt-[4px] px-6"
>
  <div class="flex flex-row align-center justify-start w-fit h-full gap-2">
    @if (isPlanEnabled()) {
      <div
        (click)="viewPlanSidebar()"
        class="py-2 px-2 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer [@media(min-width:1799px)]:hidden"
        tabindex="0"
        pTooltip="View Plan"
        tooltipPosition="bottom"
      >
        <i class="ph ph-list-magnifying-glass text-sm"></i>
      </div>
    }
    <div
      (click)="viewArchivedSidebar()"
      class="py-2 px-2 h-8 [@media(min-width:1439px)]:w-[130px] w-[30px] self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
      tabindex="0"
      pTooltip="View Previous Plans"
      tooltipPosition="bottom"
    >
      <i class="ph ph-clock-counter-clockwise text-sm"></i>
      <span class="hidden [@media(min-width:1439px)]:block">Previous Plans</span>
    </div>
    @if (hasBusinessProcess()) {
      <div
        (click)="automateProcess()"
        class="py-2 px-2 h-8 self-center font-semibold [@media(min-width:1439px)]:w-[130px] w-[30px] items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
        tabindex="0"
      >
        <i class="ph ph-head-circuit text-yellow-500 text-sm"></i>
        <span class="hidden [@media(min-width:1439px)]:block">Automate</span>
        <i
          class="ph ph-info text-neutral-400 text-base hidden [@media(min-width:1439px)]:block"
          pTooltip="Automate the process with AI Business Agents"
          tooltipPosition="bottom"
        ></i>
      </div>
    }
  </div>

  <div
    class="flex flex-row w-full align-center font-bold self-center justify-center gap-2 text-center text-[28px] font-bold p-4 border-b-0 border-l-0 border-t-0 border-r-0 border-neutral-600"
  >
    <i class="ph ph-sparkle text-[28px] pt-[7px] text-yellow-500"></i>
    AI Command Center
  </div>
  <div class="flex flex-row items-end justify-end h-full gap-2 w-[210px]">
    <div
      (click)="startNewSession()"
      class="py-2 px-2 h-8 [@media(min-width:1439px)]:w-[120px] w-[30px] self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 gap-2 hover:bg-neutral-400 cursor-pointer"
      tabindex="0"
      pTooltip="Start new session"
      tooltipPosition="bottom"
    >
      <i class="ph ph-stack-plus text-sm"></i>
      <span class="hidden [@media(min-width:1439px)]:block">New Session</span>
    </div>
    <div
      (click)="toggleZenMode()"
      class="py-2 px-2 h-8 w-[30px] self-center text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
      tabindex="0"
      pTooltip="Toggle Zen Mode"
      tooltipPosition="bottom"
    >
      <i class="ph ph-arrows-in-simple text-sm"></i>
    </div>
    <div
      (click)="viewChatSidebar()"
      class="py-2 px-2 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer [@media(min-width:1599px)]:hidden"
      tabindex="0"
      pTooltip="View Chat"
      tooltipPosition="bottom"
    >
      <i class="ph ph-chat-dots text-sm"></i>
    </div>
  </div>
</div>
<div
  class="flex flex-row w-full border-1 text-white align-center justify-stretch border-neutral-600 border-0 pt-[4px] px-6"
>
  <div
    class="flex flex-row w-full h-full px-6 py-4 text-xs justify-between items-center bg-neutral-900 rounded-lg"
  >
    <p class="text-neutral-400">
      Context:
      <span [ngClass]="currentContextDocument()?.name ? 'text-yellow-500' : 'text-neutral-400'">{{
        currentContextDocument()?.name || 'No document selected'
      }}</span>
    </p>
    <div
      (click)="!streamingAiResponse() ? viewDocumentsSidebar() : null"
      class="self-center font-semibold items-center flex text-center hover:text-yellow-500 hover:border-yellow-500 cursor-pointer border border-white-500 rounded-md px-1 py-0.5"
      tabindex="0"
      pTooltip="Change Context Document"
      tooltipPosition="bottom"
    >
      Change Document
    </div>
  </div>
</div>
